import { createFeatureSelector, createSelector } from '@ngrx/store';
import { each } from 'lodash-es';
import { QueryResultsModel } from '../../../../core/_base/crud';
import { Document } from '../models';
import { DocumentState } from '../reducers/document.reducer';

export const selectDocumentState = createFeatureSelector<DocumentState>('document');

export const selectDocumentPageLoading = createSelector(
  selectDocumentState,
  (state) => state.pageLoading,
);

export const selectDocumentActionLoading = createSelector(
  selectDocumentState,
  (state) => state.actionLoading,
);

export const selectDocumentShowInitWaitingMessage = createSelector(
  selectDocumentState,
  (state) => state.showInitWaitingMessage,
);

export const selectDocumentError = createSelector(selectDocumentState, (state) => state.error);

export const selectDocumentPage = createSelector(selectDocumentState, (state) => {
  const documents: Document[] = [];
  each(state.ids, (id: number) => documents.push(state.entities[id]));

  return new QueryResultsModel(documents, state.totalCount);
});
